export default {
  wrapper: {
    padding: '25px',
  },
};
